import React from "react";
import Modal from "react-bootstrap/Modal";
import { Checkbox, Input, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";

export default function ModalTasas({ show, setShow }) {
  return <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
    <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
      <h3 className="fw-bold m-0">Impresión de facturas - Tasas</h3>
      <a
        type="button"
        className="fw-bold text-light fs-6"
        onClick={() => setShow(false)}
      >
        Salir <i className="fa fa-times ms-2"></i>
      </a>
    </Modal.Header>
    <Modal.Body className="col-12 m-0 p-2">
      <div className="col-4 m-0 mb-2 ml-auto p-0">
        <Input label = "Fecha:" type = "date"/>
      </div>
      <div className="col-4 m-0 mb-2 ml-auto mb-2 p-0 fw-bold text-end">
        Valor Euro €: 60.30
      </div>
      <div className="col-12 m-0 mb-2 p-0">
        <Select label = 'Departamento:'></Select>
      </div>
      <div className="col-12 m-0 mb-2 p-0">
        <Textarea label = 'Descripción:' style={{ height: 70 }} />
      </div>
      <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
        <div className="col-auto m-0 p-0">
          <Checkbox label = 'General' name = 'actividad' id = 'actividad1'/>
        </div>
        <div className="col-auto m-0 p-0">
          <Checkbox label = 'Actividad Económica' name = 'actividad' id = 'actividad2'/>
        </div>
        <div className="col-auto m-0 p-0">
          <Checkbox label = 'Inmuebles Urbanos' name = 'actividad' id = 'actividad2'/>
        </div>
      </div>
      <div className="col-12 m-0 p-0 d-flex flex-wrap">
        <div className="col-9 m-0 mb-2 p-0">
          <SearchInput label = 'Nombre del Contribuyente:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Cedula o Rif:' />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Textarea label = 'Dirección:' style={{ height: 70 }} />
        </div>
      </div>
      <div className="col-4 m-0 mb-2 ml-auto p-0">
        <Select label  = 'Cantidad:' ></Select>
      </div>
      <div className="col-4 m-0 mb-2 ml-auto p-0">
        <Input label = 'Monto Total a Facturar:' />
      </div>
      <div className="col-12 m-0 mb-2 p-0">
        <Textarea label = 'Concepto:' style={{ height: 70 }} />
      </div>
    </Modal.Body>
  </Modal>
}